







































































































import EditionModal from "../core/Modals/EditionModal.vue";
import { BulletinDeSalaireApi } from "../api/BulletinDeSalaireApi";
import moment from "moment";

export default {
    name: "BulletinDeSalaireImportModal",
    components: {
        EditionModal,
    },
    props: {
        showImportModal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: false,
            month: new Date(),
            monthFormatted: moment().startOf("month").format("YYYY-MM-DD"),
            file: null,
            BulletinDeSalaireApi: new BulletinDeSalaireApi(),
            importResult: null,
            loading: false,
            documentMail: window.documentMail,
        };
    },
    watch: {
        showImportModal(newVal) {
            this.showModal = newVal;
            if (newVal) {
                // Reset form when modal is opened
                this.month = new Date();
                this.monthFormatted = moment()
                    .startOf("month")
                    .format("YYYY-MM-DD");
                this.file = null;
                this.importResult = null;
            }
        },
    },
    methods: {
        closeModal() {
            this.showModal = false;
            this.$emit("close-modal");
        },
        updateMonth(date) {
            this.monthFormatted = moment(date)
                .startOf("month")
                .format("YYYY-MM-DD");
        },
        handleFileUpload(event) {
            this.file = event.target.files[0];
        },
        importExcel() {
            if (!this.file) {
                this.importResult = {
                    error: "Veuillez sélectionner un fichier",
                };
                return Promise.reject("No file selected");
            }

            this.loading = true;
            this.importResult = null;

            return this.BulletinDeSalaireApi.importExcel(
                this.file,
                this.monthFormatted
            )
                .then((response) => {
                    this.importResult = response.data;
                    return response.data;
                })
                .catch((error) => {
                    /*this.importResult = {
                        error: error.response?.data?.error || "Une erreur est survenue lors de l'import"
                    };
                    return Promise.reject(error);*/
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
